import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../components/Layout/Loader";

const normalizeHandle = (value = "") => String(value || "").trim().toLowerCase().replace(/[^a-z0-9]/g, "");

const ProfileEntryPage = () => {
  const { handle } = useParams();
  const { loading, isAuthenticated, user } = useSelector((state) => state.user);
  const normalizedHandle = normalizeHandle(handle);

  if (!normalizedHandle) {
    return <Navigate to="/login" replace />;
  }

  if (loading !== false) {
    return <Loader />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(`/user/${normalizedHandle}`)}`} replace />;
  }

  if (normalizeHandle(user.handle) === normalizedHandle) {
    return <Navigate to={`/my-profile/${normalizedHandle}`} replace />;
  }

  return <Navigate to={`/user/${normalizedHandle}`} replace />;
};

export default ProfileEntryPage;